import { getCropUrl } from "../../../Helpers/utils";
import { ImageModel } from "../../../models/ImageModel";
import { TileModel } from "../../models/TileModel";

export default function StoryTile({ node }: TileModel) {
  const name = node.name.length > 50 ? `${node.name.substring(0, 49)}...` : node.name;
  const image = node.properties['thumbnailImage'] as ImageModel ?? null;
  const summary = node.properties['summary'].toString();
  const concatenatedSummary = summary.length > 80 ? `${summary.substring(0, 79)}...` : summary;

  return (
    <div className="cell stories-wrapper">
      <div className="thumbnail">
          <a href={node.url}>
              <img src={getCropUrl(image, 'tile')} alt={node.name} />
              <div className="caption">
                  <h6>{name}</h6>
                  <p>{concatenatedSummary}</p>
                  <span className="go"><i className="fa fa-angle-right"></i></span>
              </div>
          </a>
        </div>
    </div>
  )
}